import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import React from 'react';

import ControlStreams from './components/control/control-streams';
import ControlPanel from './components/control/control-panel';
import ControlMap from './components/control/control-map';
import Control from './components/control/control';
import NotFound from './components/404';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <div style={{margin: '10px', padding: '10px', borderRadius: '6px', border: 'solid black 1px', backdropFilter: 'blur(10px)'}}>
      <h1 style={{color:'white'}}>Until next time!</h1>
      <p style={{color:'white'}}>This site is migrating to a new one, under a different name and personality. I really appreciate anyone visiting this site over
      the years, I've had a lot of fun working on it and sharing what I've seen with everyone. All the data collection, stream setups, etc will
      stick around, just moving over to the new name. In the future the Shepardess project will continue to expand, I have massive ideas
      and I'm slowly being able to execute on them. If you're still interested, a lot of Shepardess, site and projects, will be carried over online.
      I hope you can find me!</p>
      <img src='/logo192.png' width={'192px'} height={'192px'} />
    </div>
  </>
);
//    <Router>
//      <Routes>
//        <Route path='/control/streams' element={<ControlStreams/>}/>
//        <Route path='/control/panels' element={<ControlPanel/>}/>
//        <Route path='/control/map' element={<ControlMap/>}/>
//        <Route path='/control' element={<Control/>}/>
//        <Route path='/settings' element={<App/>}/>
//        <Route path='/contact' element={<App/>}/>
//        <Route path='/home' element={<App/>}/>
//        <Route path='/' element={<App/>}/>
//        <Route path='/*' element={<NotFound/>}/>
//      </Routes>
//    </Router>